module.exports = __webpack_public_path__ + "static/media/doddle.3cd38184.png";